import { apiClient } from './apiClient';

export interface LlmProviderOption {
  key: string;
  title: string;
  models: string[];
  allowCustomModel: boolean;
  modelHint: string | null;
  requiresBaseURL: boolean;
  docsUrl: string | null;
}

export interface LlmProvidersResponse {
  providers: LlmProviderOption[];
  default: string;
}

export const llmService = {
  /** Fetch the LLM provider/model catalog that drives the agent AI-settings form. */
  async getProviders(): Promise<LlmProvidersResponse> {
    const res = await apiClient.get<any>('/core/llm/providers', { authenticate: true });
    const payload = (res as any)?.data ?? res;
    return {
      providers: Array.isArray(payload?.providers) ? payload.providers : [],
      default: payload?.default ?? 'openai',
    };
  },
};
